import React, { useState, useEffect, useCallback } from 'react'
import { Container, Row, Tabs, Tab, Form, Col, FormSelect, Button, Table, Modal } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { useParams } from "react-router-dom";
import axiosInstance from '../../utils/axios';
import MESSAGES from '../../utils/Constants';
import { fnOnChange, showToast } from '../reusables/CommonFunction';
import { fnFormValidation, fnMobileNumberValidation, fnEmailValidation } from '../reusables/HelperFormValidation';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';

const initialClinicState = {
    slug: "",
    start_date: "",
    expiring_date: "",
    clinic_name: "",
    clinic_type: "",
    doctor_name: "",
    doctor_profession: "",
    doctor_type: "",
    referred_by: "",
    registration_number: "",
    doctor_degree: "",
    mobile_number: "",
    alternate_mobile_number: "",
    brevo_whatsapp_business_number: "",
    email_id: "",
    clinic_website: "",
    communication_status: "",
    communication_sms_status: "",
    communication_whatsapp_status: "",
    communication_email_status: "",
    plan_type: "",
    clinic_address: "",
};
const initialClinicErrors = {
    start_date: "",
    expiring_date: "",
    clinic_name: "",
    clinic_type: "",
    doctor_name: "",
    doctor_profession: "",
    doctor_type: "",
    referred_by: "",
    registration_number: "",
    doctor_degree: "",
    mobile_number: "",
    alternate_mobile_number: "",
    brevo_whatsapp_business_number: "",
    email_id: "",
    clinic_website: "",
    communication_status: "",
    communication_sms_status: "",
    communication_whatsapp_status: "",
    communication_email_status: "",
    plan_type: "",
    clinic_address: "",
};

const initialTransactionState = {
    clinic_id: "",
    payment_id: "",
    payment_plan: "",
    payment_date: "",
    expiring_date: "",
    payment_mode: "",
    cheque_number: "",
    plan_amount: "",
    discount_amount: "",
    final_amount: "",
    paid_amount: "",
    outstanding_amount: "",
    is_part_payment: false,
    payment_completed: false,
    remark: "",
};

const initialTransactionErrors = {
    payment_id: "",
    payment_plan: "",
    payment_date: "",
    expiring_date: "",
    payment_mode: "",
    cheque_number: "",
    plan_amount: "",
    discount_amount: "",
    final_amount: "",
    paid_amount: "",
    outstanding_amount: "",
    is_part_payment: "",
    remark: "",
};

const initialFrontDeskState = {
    clinic_id: "",
    front_desk_name: "",
    email_id: "",
    status: "A",
};

const initialFrontDeskErrors = {
    clinic_id: "",
    front_desk_name: "",
    email_id: "",
};

const initialClinicBranchState = {
    clinic_id: "",
    branch_name: "",
    branch_address: "",
    status: "A"
};

const initialClinicBranchErrors = {
    clinic_id: "",
    branch_name: "",
    branch_address: "",
};

const ClinicDetails = () => {
    const params = useParams();
    const paymentModeList = {
        'CH': 'Cash', 'CQ': 'Cheque',
        'CC': 'Credit Card', 'DC': 'Debit Card',
        'UI': 'UPI ID'
    }
    const paymentPlanList = {
        '3': '3 Months',
        '6': '6 Months',
        '12': '1 Year',
        '24': '2 Year',
        '36': '3 Year',
        '48': '4 Year',
        '60': '5 Year'
    }
    const [loading, setLoading] = useState(false);
    const [isClinicSubmitting, setIsClinicSubmitting] = useState(false);
    const [isTransactionSubmitting, setIsTransactionSubmitting] = useState(false);
    const [isFrontDeskSubmitting, setIsFrontDeskSubmitting] = useState(false);
    const [isClinicBranchSubmitting, setIsClinicBranchSubmitting] = useState(false);
    const [isEditFronDeskSubmitting, setIsEditFrontDeskSubmitting] = useState(false);
    const [isEditClinicBranchSubmitting, setIsEditClinicBranchSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenPartPayment, setIsModalOpenPartPayment] = useState(false);
    const [isModalOpenFrontDesk, setIsModalOpenFrontDesk] = useState(false);
    const [isModalOpenClinicBranch, setIsModalOpenClinicBranch] = useState(false);
    const [isModalOpenEditFrontDesk, setIsModalOpenEditFrontDesk] = useState({});
    const [isModalOpenEditClinicBranch, setIsModalOpenEditClinicBranch] = useState({});
    const [pageLoading, setPageLoading] = useState(true)
    const [clinicId, setClinicId] = useState()
    const [expandedRow, setExpandedRow] = useState(null);

    const toggleExpand = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };
    const [previousTransactionId, setPreviousTransactionId] = useState();
    const [previousOutstanding, setPreviousOutstanding] = useState();
    const [transactionDetails, setTransactionDetails] = useState([])
    const [frontDeskDetails, setFrontDeskDetails] = useState([])
    const [clinicBranchDetails, setClinicBranchDetails] = useState([])
    const [clinicDetailsState, setClinicDetailsState] = useState(initialClinicState);
    const [clinicDetailsErrors, setClinicDetailsErrors] = useState(initialClinicErrors);
    const [newTransactionState, setNewTransactionState] = useState(initialTransactionState);
    const [newTransactionErrors, setNewTransactionErrors] = useState(initialTransactionErrors);
    const [frontDeskState, setFrontDeskState] = useState(initialFrontDeskState);
    const [frontDeskErrors, setFrontDeskErrors] = useState(initialFrontDeskErrors);
    const [clinicBranchState, setClinicBranchState] = useState(initialClinicBranchState);
    const [clinicBranchErrors, setClinicBranchErrors] = useState(initialClinicBranchErrors);
    const [editFrontDeskState, setEditFrontDeskState] = useState({
        clinic_id: "",
        slug: "",
        front_desk_name: "",
        email_id: "",
        status: "",
    });
    const [editFrontDeskErrors, setEditFrontDeskErrors] = useState({
        clinic_id: "",
        slug: "",
        front_desk_name: "",
        email_id: "",
        status: "",
    });
    const [editClinicBranchState, setEditClinicBranchState] = useState({
        clinic_id: "",
        slug: "",
        branch_name: "",
        branch_address: "",
        status: ""
    });
    const [editClinicBranchErrors, setEditClinicBranchErrors] = useState({
        clinic_id: "",
        slug: "",
        branch_name: "",
        branch_address: "",
        status: ""
    });

    const getClinicDetails = useCallback((oEvent) => {
        setLoading(true);
        axiosInstance
            .get(`/clinics/${params.clinic_id}`)
            .then(response => {
                if (response.status === 200) {
                    setClinicId(response.data.clinic['clinic_id'])
                    setClinicDetailsState(response.data.clinic)
                    setTransactionDetails(response.data.transaction)
                    setFrontDeskDetails(response.data.front_desk)
                    setClinicBranchDetails(response.data.clinic_branch)
                }
            })
            .catch(error => {
                showToast("error", "Failed to fetch clinic details")
            })
            .finally(() => {
                setLoading(false);
            });
    }, [params.clinic_id]);

    const onPressUpdateClinic = (oEvent) => {
        oEvent.preventDefault();
        setIsClinicSubmitting(true);

        const aErrorMessage = ['start_date', 'clinic_name', 'clinic_type', 'doctor_name', 'doctor_profession', 'doctor_type', 'referred_by', 'registration_number', 'doctor_degree', 'mobile_number', 'email_id', 'communication_status', 'communication_sms_status', 'communication_whatsapp_status', 'communication_email_status', 'clinic_address']
        const fErrorStatus = fnFormValidation(clinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors, aErrorMessage)

        if (fErrorStatus.length === 0) {
            const aMobileNumberCheck = ['mobile_number', 'alternate_mobile_number', 'brevo_whatsapp_business_number']
            const aMobileErrors = fnMobileNumberValidation(clinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors, aMobileNumberCheck, fErrorStatus)

            const aEmailCheck = ['email_id']
            const aEmailErrors = fnEmailValidation(clinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors, aEmailCheck, fErrorStatus)

            fErrorStatus.push(...aMobileErrors, ...aEmailErrors);
        }

        if (fErrorStatus.length === 0) {
            setLoading(true);
            axiosInstance
                .put(`/clinics/${clinicDetailsState.clinic_id}/`, clinicDetailsState)
                .then((response) => {
                    showToast("success", response.data.message);
                })
                .catch((error) => {
                    const errorData = error.response?.data;
                    if (errorData) {
                        Object.entries(errorData).forEach(([key, messages], index) => {
                            const formattedKey = key
                                .replaceAll("_", " ")
                                .replaceAll(/([A-Z])/g, " $1")
                                .replace(/^\w/, (c) => c.toUpperCase());
                            const errorMessage = `${formattedKey} | ${messages[0]}`;
                            showToast("error", errorMessage, { toastId: index });
                        });
                    }
                })
                .finally(() => {
                    setIsClinicSubmitting(false);
                    setLoading(false);
                });
        } else {
            for (let x = 0; x < fErrorStatus.length; x++) {
                showToast("error", fErrorStatus[x], { toastId: x });
            }
            setIsClinicSubmitting(false);
        }
    }

    const onPressNewTransaction = (oEvent) => {
        oEvent.preventDefault();
        setIsModalOpen(true)
        setNewTransactionState({ ...initialTransactionState, clinic_id: clinicId });
        setNewTransactionErrors(initialTransactionErrors);
    };

    const onPressSubmitNewTransaction = (oEvent) => {
        oEvent.preventDefault();
        setIsTransactionSubmitting(true);

        const requiredFields = ['payment_id', 'payment_plan', 'payment_date', 'payment_mode', 'plan_amount', 'discount_amount', 'paid_amount', 'remark'];
        const errors = {};

        // Validate required fields
        requiredFields.forEach((field) => {
            const value = newTransactionState[field];
            if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '') || (typeof value !== 'string' && value === '')) {
                errors[field] = MESSAGES.FIELD_REQUIRED;
            }
        });

        // Additional validation for specific fields
        if (newTransactionState.payment_mode === 'CQ' && !newTransactionState.cheque_number?.trim()) {
            errors.cheque_number = MESSAGES.FIELD_REQUIRED;
        }

        if (!newTransactionState.expiring_date?.trim()) {
            errors.expiring_date = MESSAGES.FIELD_REQUIRED;
        }

        // Check if there are validation errors
        if (Object.keys(errors).length > 0) {
            setNewTransactionErrors((prevErrors) => ({ ...prevErrors, ...errors }));
            setIsTransactionSubmitting(false);
            return;
        }

        // Submit the transaction
        setLoading(true);
        axiosInstance
            .post("/transactions/", newTransactionState)
            .then(response => {
                if (response.status === 201) {
                    showToast("success", response.data.message)
                    getClinicDetails()
                    setIsModalOpen(false)
                    setNewTransactionState(initialTransactionState);
                    setNewTransactionErrors(initialTransactionErrors);
                }
            })
            .catch(error => {
                showToast("error", "Failed to submit new transaction");
            })
            .finally(() => {
                setIsTransactionSubmitting(false);
                setLoading(false);
            });
    }

    const onPressNewPartPayment = (oEvent) => {
        oEvent.preventDefault();
        if (transactionDetails.length === 0) {
            showToast("error", "No transactions found for this clinic. Please create a transaction first.");
            return;
        }

        setLoading(true);
        axiosInstance
            .get(`/transactions/`, {
                params: {
                    clinic_id: clinicId,
                    type: 'part_payment',
                }
            })
            .then(response => {
                if (response.status === 200) {
                    setIsModalOpenPartPayment(true)
                    setPreviousTransactionId(response.data.data.transaction_id);
                    setPreviousOutstanding(response.data.data.outstanding_amount)
                    setNewTransactionState({
                        clinic_id: response.data.data.clinic_id,
                        payment_id: "",
                        payment_plan: response.data.data.payment_plan,
                        payment_date: "",
                        expiring_date: response.data.data.expiring_date,
                        payment_mode: "",
                        cheque_number: "",
                        plan_amount: response.data.data.plan_amount,
                        discount_amount: response.data.data.discount_amount,
                        final_amount: response.data.data.final_amount,
                        paid_amount: "",
                        outstanding_amount: "",
                        is_part_payment: response.data.data.is_part_payment,
                        payment_completed: response.data.data.payment_completed,
                        remark: "",
                    })
                    setNewTransactionErrors(initialTransactionErrors);
                }
            })
            .catch(error => {
                showToast("error", "Failed to fetch transaction details")
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const onPressSubmitNewPartPayment = (oEvent) => {
        oEvent.preventDefault();
        setIsTransactionSubmitting(true);

        const requiredFields = ['payment_id', 'payment_date', 'payment_mode', 'paid_amount', 'remark'];
        const errors = {};

        // Validate required fields
        requiredFields.forEach((field) => {
            const value = newTransactionState[field];
            if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '') || (typeof value !== 'string' && value === '')) {
                errors[field] = MESSAGES.FIELD_REQUIRED;
            }
        });

        // Additional validation for specific fields
        if (newTransactionState.payment_mode === 'CQ' && !newTransactionState.cheque_number?.trim()) {
            errors.cheque_number = MESSAGES.FIELD_REQUIRED;
        }

        // Check if there are validation errors
        if (Object.keys(errors).length > 0) {
            setNewTransactionErrors((prevErrors) => ({ ...prevErrors, ...errors }));
            setIsTransactionSubmitting(false);
            return;
        }

        // Submit the transaction
        setLoading(true);
        axiosInstance
            .put(`/transactions/${previousTransactionId}/`, newTransactionState)
            .then(response => {
                if (response.status === 200) {
                    setPreviousTransactionId();
                    showToast("success", response.data.message)
                    getClinicDetails()
                    setIsModalOpenPartPayment(false)
                    setNewTransactionState(initialTransactionState);
                    setNewTransactionErrors(initialTransactionErrors);
                }
            })
            .catch(error => {
                showToast("error", "Failed to submit new part payment");
            })
            .finally(() => {
                setIsTransactionSubmitting(false);
                setLoading(false);
            });
    }


    const onPressNewFrontDesk = (oEvent) => {
        oEvent.preventDefault();
        setIsModalOpenFrontDesk(true)
        setFrontDeskState({ ...initialFrontDeskState, clinic_id: clinicId });
        setFrontDeskErrors(initialFrontDeskErrors);
    };

    const onPressSubmitNewFrontDesk = (oEvent) => {
        oEvent.preventDefault();
        setIsFrontDeskSubmitting(true);
        const requiredFields = ['front_desk_name', 'email_id'];
        const errors = {};
        // Validate required fields
        requiredFields.forEach((field) => {
            if (!frontDeskState[field]?.trim()) {
                errors[field] = MESSAGES.FIELD_REQUIRED;
            }
        });

        if (!frontDeskState.email_id?.trim()) {
            errors.email_id = MESSAGES.FIELD_REQUIRED;
        }
        // Check if there are validation errors
        if (Object.keys(errors).length > 0) {
            setFrontDeskErrors((prevErrors) => ({ ...prevErrors, ...errors }));
            setIsFrontDeskSubmitting(false);
            return;
        }

        // Submit the front desk details
        setLoading(true);
        axiosInstance
            .post("/frontdesk/", frontDeskState)
            .then(response => {
                if (response.status === 201) {
                    showToast("success", response.data.message)
                    getClinicDetails()
                    setIsModalOpenFrontDesk(false)
                    setFrontDeskState(initialFrontDeskState);
                    setFrontDeskErrors(initialFrontDeskErrors);
                }
            })
            .catch(error => {
                showToast("error", "Failed to submit new front desk details");
            })
            .finally(() => {
                setIsFrontDeskSubmitting(false);
                setLoading(false);
            });
    }

    const onPressNewClinicBranch = (oEvent) => {
        oEvent.preventDefault();
        setIsModalOpenClinicBranch(true)
        setClinicBranchState({ ...initialClinicBranchState, clinic_id: clinicId });
        setClinicBranchErrors(initialClinicBranchErrors);
    };

    const onPressSubmitNewClinicBranch = (oEvent) => {
        oEvent.preventDefault();
        setIsClinicBranchSubmitting(true);
        const requiredFields = ['branch_name', 'branch_address'];
        const errors = {};
        // Validate required fields
        requiredFields.forEach((field) => {
            if (!clinicBranchState[field]?.trim()) {
                errors[field] = MESSAGES.FIELD_REQUIRED;
            }
        });

        // Check if there are validation errors
        if (Object.keys(errors).length > 0) {
            setClinicBranchErrors((prevErrors) => ({ ...prevErrors, ...errors }));
            setIsClinicBranchSubmitting(false);
            return;
        }

        // Submit the clinic branch details
        setLoading(true);
        axiosInstance
            .post("/clinicbranches/", clinicBranchState)
            .then(response => {
                if (response.status === 201) {
                    showToast("success", response.data.message)
                    getClinicDetails()
                    setIsModalOpenClinicBranch(false)
                    setClinicBranchState(initialClinicBranchState);
                    setClinicBranchErrors(initialClinicBranchErrors);
                }
            })
            .catch(error => {
                showToast("error", "Failed to submit new clinic branch details");
            })
            .finally(() => {
                setIsClinicBranchSubmitting(false);
                setLoading(false);
            });
    }

    const onPressEditFrontDesk = (oEvent, frontdesk) => {
        oEvent.preventDefault();
        setIsModalOpenEditFrontDesk({ ['isModalOpen_' + frontdesk.slug]: true })
        setEditFrontDeskState({
            clinic_id: clinicId,
            slug: frontdesk.slug,
            front_desk_name: frontdesk.front_desk_name,
            email_id: frontdesk.email_id,
            status: frontdesk.status
        });
        setEditFrontDeskErrors({
            clinic_id: "",
            slug: "",
            front_desk_name: "",
            email_id: "",
            status: ""
        });
    }

    const onPressEditFrontDeskSubmit = (oEvent) => {
        oEvent.preventDefault();
        setIsEditFrontDeskSubmitting(true);
        const requiredFields = ['front_desk_name', 'email_id', 'status'];
        const errors = {};
        // Validate required fields
        requiredFields.forEach((field) => {
            if (!editFrontDeskState[field]?.trim()) {
                errors[field] = MESSAGES.FIELD_REQUIRED;
            }
        }
        );
        if (!editFrontDeskState.email_id?.trim()) {
            errors.email_id = MESSAGES.FIELD_REQUIRED;
        }
        // Check if there are validation errors
        if (Object.keys(errors).length > 0) {
            setEditFrontDeskErrors((prevErrors) => ({ ...prevErrors, ...errors }));
            setIsEditFrontDeskSubmitting(false);
            return;
        }
        // Submit the front desk details
        setLoading(true);
        axiosInstance
            .put(`/frontdesk/${editFrontDeskState.slug}/`, editFrontDeskState)
            .then(response => {
                if (response.status === 200) {
                    showToast("success", response.data.message)
                    getClinicDetails()
                    setIsModalOpenEditFrontDesk({ ['isModalOpen_' + editFrontDeskState.slug]: false })
                    setEditFrontDeskState({
                        clinic_id: "",
                        slug: "",
                        front_desk_name: "",
                        email_id: "",
                        status: ""
                    });
                    setEditFrontDeskErrors({
                        clinic_id: "",
                        slug: "",
                        front_desk_name: "",
                        email_id: "",
                        status: ""
                    });
                }
            })
            .catch(error => {
                showToast("error", "Failed to submit new front desk details");
            })
            .finally(() => {
                setIsEditFrontDeskSubmitting(false);
                setLoading(false);
            });
    }

    const onPressEditClinicBranch = (oEvent, clinicbranch) => {
        oEvent.preventDefault();
        setIsModalOpenEditClinicBranch({ ['isModalOpen_' + clinicbranch.slug]: true })
        setEditClinicBranchState({
            clinic_id: clinicId,
            slug: clinicbranch.slug,
            branch_name: clinicbranch.branch_name,
            branch_address: clinicbranch.branch_address,
            status: clinicbranch.status
        });
        setEditClinicBranchErrors({
            clinic_id: "",
            slug: "",
            branch_name: "",
            branch_address: "",
            status: ""
        });
    }

    const onPressEditClinicBranchSubmit = (oEvent) => {
        oEvent.preventDefault();
        setIsEditClinicBranchSubmitting(true);
        const requiredFields = ['branch_name', 'branch_address', 'status'];
        const errors = {};
        // Validate required fields
        requiredFields.forEach((field) => {
            if (!editClinicBranchState[field]?.trim()) {
                errors[field] = MESSAGES.FIELD_REQUIRED;
            }
        });
        // Check if there are validation errors
        if (Object.keys(errors).length > 0) {
            setEditClinicBranchErrors((prevErrors) => ({ ...prevErrors, ...errors }));
            setIsEditClinicBranchSubmitting(false);
            return;
        }
        // Submit the clinic branch details
        setLoading(true);
        axiosInstance
            .put(`/clinicbranches/${editClinicBranchState.slug}/`, editClinicBranchState)
            .then(response => {
                if (response.status === 200) {
                    showToast("success", response.data.message)
                    getClinicDetails()
                    setIsModalOpenEditClinicBranch({ ['isModalOpen_' + editClinicBranchState.slug]: false })
                    setEditClinicBranchState({
                        clinic_id: "",
                        slug: "",
                        branch_name: "",
                        branch_address: "",
                        status: ""
                    });
                    setEditClinicBranchErrors({
                        clinic_id: "",
                        slug: "",
                        branch_name: "",
                        branch_address: "",
                    });
                }
            })
            .catch(error => {
                showToast("error", "Failed to submit new clinic branch details");
            })
            .finally(() => {
                setIsEditClinicBranchSubmitting(false);
                setLoading(false);
            });
    }

    useEffect(() => {
        if (pageLoading) {
            getClinicDetails()
        }
        setPageLoading(false);

    }, [pageLoading, getClinicDetails]);

    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <Tabs>
                            <Tab eventKey="clinic" title="Clinic Details">
                                <div className='content-section col-md-8 mt-3'>
                                    <Form autoComplete="off" noValidate>
                                        <Form.Group className="mb-3" controlId="formClinicName">
                                            <Form.Label className="required">Clinic Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clinic_name"
                                                placeholder='Clinic Name'
                                                value={clinicDetailsState.clinic_name || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.clinic_name}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.clinic_name}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formDoctorName">
                                            <Form.Label className="required">Doctor Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="doctor_name"
                                                placeholder='Doctor Name'
                                                value={clinicDetailsState.doctor_name || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.doctor_name}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.doctor_name}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formDoctorProfession">
                                            <Form.Label className="required">Doctor Profession</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="doctor_profession"
                                                placeholder='Doctor Profession'
                                                value={clinicDetailsState.doctor_profession || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.doctor_profession}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.doctor_profession}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Row className="mb-3">
                                            <Form.Group className="mb-3" controlId="formClinicType">
                                                <Form.Label className="required">Clinic Type</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="clinic_type"
                                                    value={clinicDetailsState.clinic_type || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.clinic_type}>
                                                    <option value="">Select Clinic Type</option>
                                                    <option value="AL">Allopathy</option>
                                                    <option value="HM">Homeopathy</option>
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.clinic_type}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} controlId="formDoctorType">
                                                <Form.Label className="required">Doctor Type</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="doctor_type"
                                                    value={clinicDetailsState.doctor_type || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.doctor_type}>
                                                    <option value="">Select Doctor Type</option>
                                                    <option value="dentist">Dentist</option>
                                                    <option value="dermatologist">Dermatologist</option>
                                                    <option value="ent_specialist">ENT Specialist</option>
                                                    <option value="gastroenterologist">Gastroenterologist</option>
                                                    <option value="general_practitioner">General Practitioner</option>
                                                    <option value="gynecologist">Gynecologist</option>
                                                    <option value="homeopathy">Homeopathy</option>
                                                    <option value="orthopedic">Orthopedic</option>
                                                    <option value="pediatrician">Pediatrician</option>
                                                    <option value="physiotherapist">Physiotherapist</option>
                                                    <option value="psychiatrist">Psychiatrist</option>
                                                    <option value="psychologist">Psychologist</option>
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.doctor_type}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formStartDate">
                                                <Form.Label className="required">Start Date</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="start_date"
                                                    value={clinicDetailsState.start_date || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.start_date}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.start_date}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} controlId="formExpiredAt">
                                                <Form.Label>Expiring At</Form.Label>
                                                <Form.Control disabled
                                                    type="date"
                                                    name="expiring_date"
                                                    value={clinicDetailsState.expiring_date || ""}
                                                />
                                            </Form.Group>
                                        </Row>

                                        <Form.Group className="mb-3" controlId="formReferredBy">
                                            <Form.Label className="required">Referred By</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="referred_by"
                                                placeholder='Referred By'
                                                value={clinicDetailsState.referred_by || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.referred_by}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.referred_by}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formDoctorDegree">
                                                <Form.Label className="required">Doctor Degree</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="doctor_degree"
                                                    placeholder='Doctor Degree'
                                                    value={clinicDetailsState.doctor_degree || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.doctor_degree}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.doctor_degree}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} controlId="formRegistrationNumber">
                                                <Form.Label className="required">Registration Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="registration_number"
                                                    placeholder='Registration Number'
                                                    value={clinicDetailsState.registration_number || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.registration_number}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.registration_number}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formMobileNumber">
                                                <Form.Label className="required">Mobile Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="mobile_number"
                                                    placeholder='Mobile Number'
                                                    value={clinicDetailsState.mobile_number || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.mobile_number}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.mobile_number}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} controlId="formAltMobileNumber">
                                                <Form.Label>Alternate Mobile Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="alternate_mobile_number"
                                                    placeholder='Alternate Mobile Number'
                                                    value={clinicDetailsState.alternate_mobile_number || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.alternate_mobile_number}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.alternate_mobile_number}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Form.Group className="mb-3" controlId="formBrevoWhatsappBusinessNumber">
                                            <Form.Label>Brevo WhatsApp Business Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="brevo_whatsapp_business_number"
                                                placeholder='Brevo WhatsApp Business Number'
                                                value={clinicDetailsState.brevo_whatsapp_business_number || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.brevo_whatsapp_business_number}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.brevo_whatsapp_business_number}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formEmailAddress">
                                            <Form.Label className="required">Email Address</Form.Label>
                                            <Form.Control disabled
                                                type="email"
                                                name="email_id"
                                                placeholder='Email Address'
                                                value={clinicDetailsState.email_id || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.email_id}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.email_id}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formWebsite">
                                            <Form.Label>Website</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clinic_website"
                                                placeholder='Website'
                                                value={clinicDetailsState.clinic_website || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.clinic_website}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.clinic_website}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formCommunicationStatus">
                                                <Form.Label className="required">Communication Status</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="communication_status"
                                                    value={clinicDetailsState.communication_status || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.communication_status}>
                                                    <option value="">Select Communication Option</option>
                                                    <option value="A">Active</option>
                                                    <option value="D">Deactive</option>
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.communication_status}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} controlId="formCommunicationEmailStatus">
                                                <Form.Label className="required">Email Communication Status</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="communication_email_status"
                                                    value={clinicDetailsState.communication_email_status || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.communication_email_status}>
                                                    <option value="">Select Communication Option</option>
                                                    <option value="A">Active</option>
                                                    <option value="D">Deactive</option>
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.communication_email_status}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formCommunicationSmsStatus">
                                                <Form.Label className="required">SMS Communication Status</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="communication_sms_status"
                                                    value={clinicDetailsState.communication_sms_status || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.communication_sms_status}>
                                                    <option value="">Select Communication Option</option>
                                                    <option value="A">Active</option>
                                                    <option value="D">Deactive</option>
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.communication_sms_status}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} controlId="formCommunicationWhatsappStatus">
                                                <Form.Label className="required">WhatsApp Communication Status</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="communication_whatsapp_status"
                                                    value={clinicDetailsState.communication_whatsapp_status || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                    isInvalid={clinicDetailsErrors.communication_whatsapp_status}>
                                                    <option value="">Select Communication Option</option>
                                                    <option value="A">Active</option>
                                                    <option value="D">Deactive</option>
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">{clinicDetailsErrors.communication_whatsapp_status}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Form.Group className="mb-3" controlId="formPlanType">
                                            <Form.Label className="required">Plan Type</Form.Label>
                                            <Form.Control disabled
                                                type="text"
                                                name="plan_type"
                                                placeholder='Plan Type'
                                                value={"F" === clinicDetailsState.plan_type ? "Free Trial Plan" : "Paid Subscription Plan"}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.plan_type}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.plan_type}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formClinicAddress">
                                            <Form.Label className="required">Clinic Address</Form.Label>
                                            <Form.Control as="textarea" rows={3}
                                                name="clinic_address"
                                                placeholder='Clinic Address'
                                                value={clinicDetailsState.clinic_address || ""}
                                                onChange={(oEvent) => fnOnChange(oEvent, clinicDetailsState, setClinicDetailsState, clinicDetailsErrors, setClinicDetailsErrors)}
                                                isInvalid={clinicDetailsErrors.clinic_address}
                                            />
                                            <Form.Control.Feedback type="invalid">{clinicDetailsErrors.clinic_address}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formLogin">
                                            <Button type="submit" variant="primary" className="form-control" onClick={onPressUpdateClinic}>
                                                {isClinicSubmitting ? 'Submitting...' : 'Update Clinic'}
                                            </Button>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </Tab>

                            <Tab eventKey="transaction" title="Transaction Information">
                                <Button type='button' variant='primary' style={{ float: "right" }} className='mt-3' onClick={onPressNewPartPayment} >New Part Payment</Button>
                                <Button type='button' variant='primary' style={{ float: "right" }} className='mr-3 mt-3' onClick={onPressNewTransaction} >New Transaction</Button>

                                <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} backdrop="static" keyboard={false} centered>
                                    <Modal.Header>
                                        <Modal.Title>New Transaction</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form autoComplete="off" noValidate>
                                            <Form.Group className="mb-3" controlId="formTransactionID">
                                                <Form.Label className="required">Transaction ID</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="payment_id"
                                                    placeholder='Transaction ID'
                                                    value={newTransactionState.payment_id || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                    isInvalid={newTransactionErrors.payment_id}
                                                />
                                                <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_id}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formPaymentPlan">
                                                    <Form.Label className="required">Payment Plan</Form.Label>
                                                    <Form.Control
                                                        as={FormSelect}
                                                        name="payment_plan"
                                                        value={newTransactionState.payment_plan || ""}
                                                        onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                        isInvalid={newTransactionErrors.payment_plan}>
                                                        <option value="">Select Payment Plan</option>
                                                        <option value="3">3 Months</option>
                                                        <option value="6">6 Months</option>
                                                        <option value="12">1 Year</option>
                                                        <option value="24">2 Year</option>
                                                        <option value="36">3 Year</option>
                                                        <option value="48">4 Year</option>
                                                        <option value="60">5 Year</option>
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_plan}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formPaymentMode">
                                                    <Form.Label className="required">Payment Mode</Form.Label>
                                                    <Form.Control
                                                        as={FormSelect}
                                                        name="payment_mode"
                                                        value={newTransactionState.payment_mode || ""}
                                                        onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                        isInvalid={newTransactionErrors.payment_mode}>
                                                        <option value="">Select Payment Mode</option>
                                                        <option value="CH">Cash</option>
                                                        <option value="CQ">Cheque</option>
                                                        <option value="CC">Credit Card</option>
                                                        <option value="DC">Debit Card</option>
                                                        <option value="UI">UPI ID</option>
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_mode}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formPaymentDate">
                                                    <Form.Label className="required">Payment Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="payment_date"
                                                        value={newTransactionState.payment_date || ""}
                                                        onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                        isInvalid={newTransactionErrors.payment_date}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_date}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formExpiringDate">
                                                    <Form.Label>Expiring Date</Form.Label>
                                                    <Form.Control readOnly
                                                        type="date"
                                                        name="expiring_date"
                                                        value={newTransactionState.expiring_date || ""}
                                                        isInvalid={newTransactionErrors.expiring_date}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.expiring_date}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>

                                            {newTransactionState.payment_mode === 'CQ' ?
                                                <Form.Group className="mb-3" controlId="formChequeNumber">
                                                    <Form.Label>Cheque Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="cheque_number"
                                                        placeholder='Cheque Number'
                                                        value={newTransactionState.cheque_number || ""}
                                                        onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                        isInvalid={newTransactionErrors.cheque_number}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.cheque_number}</Form.Control.Feedback>
                                                </Form.Group>
                                                : <> </>
                                            }

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formPlanAmount">
                                                    <Form.Label className="required">Plan Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="plan_amount"
                                                        placeholder='Plan Amount'
                                                        value={newTransactionState.plan_amount || ""}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value.toString() || "0");
                                                            setNewTransactionState((prev) => {
                                                                const discount = parseInt(prev.discount_amount || "0");
                                                                const paid = parseInt(prev.paid_amount || "0");
                                                                const finalAmount = discount > 0 ? value - discount : value;
                                                                const outstandingAmount = finalAmount - paid;
                                                                return {
                                                                    ...prev,
                                                                    plan_amount: value,
                                                                    final_amount: finalAmount,
                                                                    outstanding_amount: outstandingAmount,
                                                                    is_part_payment: outstandingAmount > 0 ? true : false,
                                                                    payment_completed: outstandingAmount > 0 ? false : true
                                                                };
                                                            });
                                                        }}
                                                        isInvalid={newTransactionErrors.plan_amount}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.plan_amount}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formDiscountAmount">
                                                    <Form.Label className="required">Discount Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="discount_amount"
                                                        placeholder='Discount Amount'
                                                        value={newTransactionState.discount_amount || ""}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value.toString() || "0");
                                                            setNewTransactionState((prev) => {
                                                                const plan = parseInt(prev.plan_amount || "0");
                                                                const paid = parseInt(prev.paid_amount || "0");
                                                                const finalAmount = value > 0 ? plan - value : plan;
                                                                const outstandingAmount = finalAmount - paid;
                                                                return {
                                                                    ...prev,
                                                                    discount_amount: value,
                                                                    final_amount: finalAmount,
                                                                    outstanding_amount: outstandingAmount,
                                                                    is_part_payment: outstandingAmount > 0 ? true : false,
                                                                    payment_completed: outstandingAmount > 0 ? false : true
                                                                };
                                                            });
                                                        }}
                                                        isInvalid={newTransactionErrors.discount_amount}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.discount_amount}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>

                                            <Form.Group className="mb-3" controlId="formFinalAmount">
                                                <Form.Label className="required">Final Amount</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="final_amount"
                                                    placeholder='Final Amount'
                                                    value={newTransactionState.final_amount || ""}
                                                    readOnly
                                                    disabled
                                                />
                                            </Form.Group>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formPaidAmount">
                                                    <Form.Label className="required">Paid Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="paid_amount"
                                                        placeholder="Paid Amount"
                                                        value={newTransactionState.paid_amount || ""}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value.toString() || "0");
                                                            setNewTransactionState((prev) => {
                                                                const finalAmount = parseInt(prev.plan_amount || "0") - parseInt(prev.discount_amount || "0");
                                                                const outstandingAmount = finalAmount - value;
                                                                return {
                                                                    ...prev,
                                                                    paid_amount: value,
                                                                    final_amount: finalAmount,
                                                                    outstanding_amount: outstandingAmount,
                                                                    is_part_payment: outstandingAmount > 0 ? true : false,
                                                                    payment_completed: outstandingAmount > 0 ? false : true
                                                                };
                                                            });
                                                        }}
                                                        isInvalid={newTransactionErrors.paid_amount}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.paid_amount}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formOutstandingAmount">
                                                    <Form.Label>Outstanding Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="outstanding_amount"
                                                        placeholder="Outstanding Amount"
                                                        value={newTransactionState.outstanding_amount || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Row>

                                            <Form.Group className="mb-3" controlId="formIsPartPayment">
                                                <Form.Label className="required">Part Payment</Form.Label>
                                                <Form.Control
                                                    as={FormSelect}
                                                    name="is_part_payment"
                                                    value={newTransactionState.is_part_payment ? "true" : "false"}
                                                    readOnly
                                                    disabled>
                                                    <option value="">Select</option>
                                                    <option value="false">Full Payment</option>
                                                    <option value="true">Part Payment</option>
                                                </Form.Control>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formRemark">
                                                <Form.Label className="required">Remark</Form.Label>
                                                <Form.Control as="textarea" rows={3}
                                                    name="remark"
                                                    placeholder='Remark'
                                                    value={newTransactionState.remark || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                    isInvalid={newTransactionErrors.remark}
                                                />
                                                <Form.Control.Feedback type="invalid">{newTransactionErrors.remark}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formLogin">
                                                <Button type="submit" variant="primary" className="form-control" onClick={onPressSubmitNewTransaction}>
                                                    {isTransactionSubmitting ? 'Submitting...' : 'Submit Transaction'}
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                </Modal>

                                <Modal show={isModalOpenPartPayment} onHide={() => setIsModalOpenPartPayment(false)} backdrop="static" keyboard={false} centered>
                                    <Modal.Header>
                                        <Modal.Title>New Part Payment</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form autoComplete="off" noValidate>
                                            <Form.Group className="mb-3" controlId="formTransactionID">
                                                <Form.Label className="required">Transaction ID</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="payment_id"
                                                    placeholder='Transaction ID'
                                                    value={newTransactionState.payment_id || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                    isInvalid={newTransactionErrors.payment_id}
                                                />
                                                <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_id}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formPaymentDate">
                                                    <Form.Label className="required">Payment Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="payment_date"
                                                        value={newTransactionState.payment_date || ""}
                                                        onChange={(oEvent) => {
                                                            setNewTransactionState((prev) => {
                                                                return {
                                                                    ...prev,
                                                                    payment_date: oEvent.target.value
                                                                };
                                                            })
                                                        }}
                                                        isInvalid={newTransactionErrors.payment_date}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_date}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formPaymentMode">
                                                    <Form.Label className="required">Payment Mode</Form.Label>
                                                    <Form.Control
                                                        as={FormSelect}
                                                        name="payment_mode"
                                                        value={newTransactionState.payment_mode || ""}
                                                        onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                        isInvalid={newTransactionErrors.payment_mode}>
                                                        <option value="">Select Payment Mode</option>
                                                        <option value="CH">Cash</option>
                                                        <option value="CQ">Cheque</option>
                                                        <option value="CC">Credit Card</option>
                                                        <option value="DC">Debit Card</option>
                                                        <option value="UI">UPI ID</option>
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.payment_mode}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>

                                            {newTransactionState.payment_mode === 'CQ' ?
                                                <Form.Group className="mb-3" controlId="formChequeNumber">
                                                    <Form.Label>Cheque Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="cheque_number"
                                                        placeholder='Cheque Number'
                                                        value={newTransactionState.cheque_number || ""}
                                                        onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                        isInvalid={newTransactionErrors.cheque_number}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.cheque_number}</Form.Control.Feedback>
                                                </Form.Group>
                                                : <> </>
                                            }

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formAmount">
                                                    <Form.Label className="required">Plan Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="plan_amount"
                                                        placeholder='Plan Amount'
                                                        value={newTransactionState.plan_amount || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formDiscountAmount">
                                                    <Form.Label className="required">Discount Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="discount_amount"
                                                        placeholder='Discount Amount'
                                                        value={newTransactionState.discount_amount || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formFinalAmount">
                                                    <Form.Label className="required">Final Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="final_amount"
                                                        placeholder='Final Amount'
                                                        value={newTransactionState.final_amount || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formPrevOutstanding">
                                                    <Form.Label className="required">Prev Outstanding Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="prev_outstading_amount"
                                                        placeholder='Previous Outstanding Amount'
                                                        value={previousOutstanding || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="formPaidAmount">
                                                    <Form.Label className="required">Paid Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="paid_amount"
                                                        placeholder="Paid Amount"
                                                        value={newTransactionState.paid_amount || ""}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value.toString() || "0");
                                                            setNewTransactionState((prev) => {
                                                                const finalAmount = parseInt(prev.plan_amount || "0") - parseInt(prev.discount_amount || "0");
                                                                const outstandingAmount = previousOutstanding - value;
                                                                return {
                                                                    ...prev,
                                                                    paid_amount: value,
                                                                    final_amount: finalAmount,
                                                                    outstanding_amount: outstandingAmount,
                                                                    is_part_payment: outstandingAmount > 0 ? true : false,
                                                                    payment_completed: outstandingAmount > 0 ? false : true
                                                                };
                                                            });
                                                        }}
                                                        isInvalid={newTransactionErrors.paid_amount}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{newTransactionErrors.paid_amount}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formOutstandingAmount">
                                                    <Form.Label>Outstanding Amount</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="outstanding_amount"
                                                        placeholder="Outstanding Amount"
                                                        value={newTransactionState.outstanding_amount || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Row>

                                            <Form.Group className="mb-3" controlId="formRemark">
                                                <Form.Label className="required">Remark</Form.Label>
                                                <Form.Control as="textarea" rows={3}
                                                    name="remark"
                                                    placeholder='Remark'
                                                    value={newTransactionState.remark || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, newTransactionState, setNewTransactionState, newTransactionErrors, setNewTransactionErrors)}
                                                    isInvalid={newTransactionErrors.remark}
                                                />
                                                <Form.Control.Feedback type="invalid">{newTransactionErrors.remark}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formLogin">
                                                <Button type="submit" variant="primary" className="form-control" onClick={onPressSubmitNewPartPayment}>
                                                    {isTransactionSubmitting ? 'Submitting...' : 'Submit Part Payment'}
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                </Modal>

                                {transactionDetails.length > 0 ?
                                    <Table bordered hover responsive className="mt-3 compact-table">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: '110px' }}>Invoice No.</th>
                                                <th style={{ minWidth: '150px' }}>Transaction ID</th>
                                                <th style={{ minWidth: '55px ' }}>Payment Date</th>
                                                <th style={{ minWidth: '55px' }}>Plan</th>
                                                <th style={{ minWidth: '60px' }}>Mode</th>
                                                <th>Amount</th>
                                                <th>Discount</th>
                                                <th>Final</th>
                                                <th>Paid</th>
                                                <th>Outstanding</th>
                                                <th>Part Payment</th>
                                                <th>Status</th>
                                                <th style={{ minWidth: '120px' }}>Remark</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactionDetails.map((txn, index) => (
                                                <React.Fragment key={txn.transaction_id}>
                                                    <tr>
                                                        <td className="text-start">{txn.invoice_number}</td>
                                                        <td className="text-start">
                                                            <span className="truncate-cell" title={txn.payment_id}>
                                                                {txn.payment_id}
                                                            </span>
                                                        </td>
                                                        <td className='text-center'>{txn.payment_date}</td>
                                                        <td className='text-start'>{paymentPlanList[txn.payment_plan]}</td>
                                                        <td className='text-start'>{txn.payment_mode !== 'CQ' ? paymentModeList[txn.payment_mode]
                                                            : `${paymentModeList[txn.payment_mode]} - ${txn.cheque_number}`}</td>
                                                        <td className='text-end'>₹{txn.plan_amount}</td>
                                                        <td className='text-end'>₹{txn.discount_amount}</td>
                                                        <td className='text-end'>₹{txn.final_amount}</td>
                                                        <td className='text-end'>₹{txn.paid_amount}</td>
                                                        <td className='text-end'>₹{txn.outstanding_amount}</td>
                                                        <td className='text-center'>{txn.is_part_payment ? 'Yes' : 'No'}</td>
                                                        <td>{txn.payment_completed ? 'Completed' : 'Pending'}</td>
                                                        <td className="text-start">
                                                            <span className="truncate-cell" title={txn.remark}>
                                                                {txn.remark}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            {txn.is_part_payment && (
                                                                <Button
                                                                    type="button"
                                                                    variant="primary"
                                                                    size="sm"
                                                                    onClick={() => toggleExpand(index)}
                                                                >
                                                                    {expandedRow === index ? 'Hide' : 'View'}
                                                                </Button>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Part Payment History Section */}
                                                    {expandedRow === index && txn.part_payments?.length > 0 && (
                                                        <tr>
                                                            <td colSpan="14">
                                                                <strong>Part Payment History:</strong>
                                                                <Table bordered hover responsive className='mt-2 compact-table'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Invoice No.</th>
                                                                            <th>Date</th>
                                                                            <th>Mode</th>
                                                                            <th>Paid</th>
                                                                            <th>Outstanding</th>
                                                                            <th>Remark</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {txn.part_payments.map((pp) => (
                                                                            <tr key={pp.invoice_number}>
                                                                                <td className="text-start">{pp.invoice_number}</td>
                                                                                <td>{pp.payment_date}</td>
                                                                                <td>{paymentModeList[pp.payment_mode]}</td>
                                                                                <td className='text-end'>₹{pp.paid_amount}</td>
                                                                                <td className='text-end'>₹{pp.outstanding_amount}</td>
                                                                                <td className="text-start">{pp.remark}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </Table>
                                    : <> </>}
                            </Tab>

                            <Tab eventKey="branch" title="Branch Information">
                                <Button type='button' variant='primary' style={{ float: "right" }} className='mt-3' onClick={onPressNewClinicBranch} >New Clinic Branch</Button>
                                <Modal size="lg" backdrop="static" keyboard={false} show={isModalOpenClinicBranch} onHide={() => setIsModalOpenClinicBranch(false)} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>New Clinic Branch</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form autoComplete="off" noValidate>
                                            <Form.Group className="mb-3" controlId="formClinicBranchName">
                                                <Form.Label className="required">Branch Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="branch_name"
                                                    placeholder='Branch Name'
                                                    value={clinicBranchState.branch_name || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicBranchState, setClinicBranchState, clinicBranchErrors, setClinicBranchErrors)}
                                                    isInvalid={clinicBranchErrors.branch_name}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicBranchErrors.branch_name}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formClinicBranchAddress">
                                                <Form.Label className="required">Branch Address</Form.Label>
                                                <Form.Control as="textarea" rows={3}
                                                    name="branch_address"
                                                    placeholder='Branch Address'
                                                    value={clinicBranchState.branch_address || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, clinicBranchState, setClinicBranchState, clinicBranchErrors, setClinicBranchErrors)}
                                                    isInvalid={clinicBranchErrors.branch_address}
                                                />
                                                <Form.Control.Feedback type="invalid">{clinicBranchErrors.branch_address}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formBranch">
                                                <Button type="submit" variant="primary" className="form-control" onClick={onPressSubmitNewClinicBranch}>
                                                    {isClinicBranchSubmitting ? 'Submitting...' : 'Submit Clinic Branch'}
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                </Modal>
                                {clinicBranchDetails.length > 0 ?
                                    <Table bordered hover responsive className='mt-3'>
                                        <thead light="true">
                                            <tr>
                                                <th style={{ width: "2rem" }}>#</th>
                                                <th style={{ width: "7rem" }}>Branch Name</th>
                                                <th style={{ width: "20rem" }}>Branch Address</th>
                                                <th style={{ width: "2rem" }}>Status</th>
                                                <th style={{ width: "3rem" }}>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clinicBranchDetails.map((branch, index) => {
                                                return [
                                                    <tr key={branch.clinic_branch_id}>
                                                        <td>{index + 1}</td>
                                                        <td>{branch.branch_name}</td>
                                                        <td>{branch.branch_address}</td>
                                                        <td>{branch.status === 'A' ? "Active" : "Inactive"}</td>
                                                        <td>
                                                            <Button type='button' variant='info' size='sm' onClick={oEvent => onPressEditClinicBranch(oEvent, branch)} >Edit</Button>
                                                            <Modal size="lg" backdrop="static" keyboard={false} show={isModalOpenEditClinicBranch['isModalOpen_' + branch.slug]} onHide={() => setIsModalOpenEditClinicBranch({ ...isModalOpenEditClinicBranch, ['isModalOpen_' + branch.slug]: false })} centered>
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Edit Clinic Branch</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <Form autoComplete="off" noValidate>
                                                                        <Form.Group className="mb-3" controlId="formClinicBranchName">
                                                                            <Form.Label className="required">Branch Name</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="branch_name"
                                                                                placeholder='Branch Name'
                                                                                value={editClinicBranchState.branch_name || ""}
                                                                                onChange={(oEvent) => fnOnChange(oEvent, editClinicBranchState, setEditClinicBranchState, editClinicBranchErrors, setEditClinicBranchErrors)}
                                                                                isInvalid={editClinicBranchErrors.branch_name}
                                                                            />
                                                                            <Form.Control.Feedback type="invalid">{editClinicBranchErrors.branch_name}</Form.Control.Feedback>
                                                                        </Form.Group>

                                                                        <Form.Group className="mb-3" controlId="formClinicBranchAddress">
                                                                            <Form.Label className="required">Branch Address</Form.Label>
                                                                            <Form.Control as="textarea" rows={3}
                                                                                name="branch_address"
                                                                                placeholder='Branch Address'
                                                                                value={editClinicBranchState.branch_address || ""}
                                                                                onChange={(oEvent) => fnOnChange(oEvent, editClinicBranchState, setEditClinicBranchState, editClinicBranchErrors, setEditClinicBranchErrors)}
                                                                                isInvalid={editClinicBranchErrors.branch_address}
                                                                            />
                                                                            <Form.Control.Feedback type="invalid">{editClinicBranchErrors.branch_address}</Form.Control.Feedback>
                                                                        </Form.Group>

                                                                        <Form.Group className="mb-3" controlId="formClinicBranchStatus">
                                                                            <Form.Label>Branch Status</Form.Label>
                                                                            <Form.Control
                                                                                as={FormSelect}
                                                                                name="status"
                                                                                value={editClinicBranchState.status || ""}
                                                                                onChange={(oEvent) => fnOnChange(oEvent, editClinicBranchState, setEditClinicBranchState, editClinicBranchErrors, setEditClinicBranchErrors)}
                                                                                isInvalid={editClinicBranchErrors.status}>
                                                                                <option value="">Select Status</option>
                                                                                <option value="A">Active</option>
                                                                                <option value="I">Inactive</option>
                                                                            </Form.Control>
                                                                            <Form.Control.Feedback type="invalid">{editClinicBranchErrors.status}</Form.Control.Feedback>
                                                                        </Form.Group>

                                                                        <Form.Group className="mb-3" controlId="formBranch">
                                                                            <Button type="submit" variant="primary" className="form-control" onClick={onPressEditClinicBranchSubmit}>
                                                                                {isEditClinicBranchSubmitting ? 'Submitting...' : 'Submit Clinic Branch'}
                                                                            </Button>
                                                                        </Form.Group>
                                                                    </Form>
                                                                </Modal.Body>
                                                            </Modal>
                                                        </td>
                                                    </tr>
                                                ]
                                            })}
                                        </tbody>
                                    </Table>
                                    : <> </>}
                            </Tab>

                            <Tab eventKey="frontdesk" title="Front Desk Information">
                                <Button type='button' variant='primary' style={{ float: "right" }} className='mt-3' onClick={onPressNewFrontDesk} >New Front Desk</Button>
                                <Modal size="lg" backdrop="static" keyboard={false} show={isModalOpenFrontDesk} onHide={() => setIsModalOpenFrontDesk(false)} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>New Front Desk</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form autoComplete="off" noValidate>
                                            <Form.Group className="mb-3" controlId="formFrontDeskName">
                                                <Form.Label className="required">Front Desk Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="front_desk_name"
                                                    placeholder='Front Desk Name'
                                                    value={frontDeskState.front_desk_name || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, frontDeskState, setFrontDeskState, frontDeskErrors, setFrontDeskErrors)}
                                                    isInvalid={frontDeskErrors.front_desk_name}
                                                />
                                                <Form.Control.Feedback type="invalid">{frontDeskErrors.front_desk_name}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formFrontDeskEmail">
                                                <Form.Label className="required">Email Address</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email_id"
                                                    placeholder='Email Address'
                                                    value={frontDeskState.email_id || ""}
                                                    onChange={(oEvent) => fnOnChange(oEvent, frontDeskState, setFrontDeskState, frontDeskErrors, setFrontDeskErrors)}
                                                    isInvalid={frontDeskErrors.email_id}
                                                />
                                                <Form.Control.Feedback type="invalid">{frontDeskErrors.email_id}</Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formBranch">
                                                <Button type="submit" variant="primary" className="form-control" onClick={onPressSubmitNewFrontDesk}>
                                                    {isFrontDeskSubmitting ? 'Submitting...' : 'Submit Front Desk'}
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                </Modal>
                                {frontDeskDetails.length > 0 ?
                                    <Table bordered hover responsive className='mt-3'>
                                        <thead light="true">
                                            <tr>
                                                <th style={{ width: "2rem" }}>#</th>
                                                <th style={{ width: "12rem" }}>Front Desk Name</th>
                                                <th style={{ width: "15rem" }}>Front Desk Email</th>
                                                <th style={{ width: "2rem" }}>Status</th>
                                                <th style={{ width: "3rem" }}>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {frontDeskDetails.map((frontdesk, index) => {
                                                return [
                                                    <tr key={frontdesk.front_desk_id}>
                                                        <td>{index + 1}</td>
                                                        <td>{frontdesk.front_desk_name}</td>
                                                        <td>{frontdesk.email_id}</td>
                                                        <td>{frontdesk.status === 'A' ? "Active" : "Inactive"}</td>
                                                        <td>
                                                            <Button type='button' variant='info' size='sm' onClick={oEvent => onPressEditFrontDesk(oEvent, frontdesk)} >Edit</Button>
                                                            <Modal size="lg" backdrop="static" keyboard={false} show={isModalOpenEditFrontDesk['isModalOpen_' + frontdesk.slug]} onHide={() => setIsModalOpenEditFrontDesk({ ...isModalOpenEditFrontDesk, ['isModalOpen_' + frontdesk.slug]: false })} centered>
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Edit Front Desk</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <Form autoComplete="off" noValidate>
                                                                        <Form.Group className="mb-3" controlId="formFrontDeskName">
                                                                            <Form.Label className="required">Front Desk Name</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="front_desk_name"
                                                                                placeholder='Front Desk Name'
                                                                                value={editFrontDeskState.front_desk_name || ""}
                                                                                onChange={(oEvent) => fnOnChange(oEvent, editFrontDeskState, setEditFrontDeskState, editFrontDeskErrors, setEditFrontDeskErrors)}
                                                                                isInvalid={editFrontDeskErrors.front_desk_name}
                                                                            />
                                                                            <Form.Control.Feedback type="invalid">{editFrontDeskErrors.front_desk_name}</Form.Control.Feedback>
                                                                        </Form.Group>

                                                                        <Form.Group className="mb-3" controlId="formFrontDeskEmail">
                                                                            <Form.Label className="required">Email Address</Form.Label>
                                                                            <Form.Control
                                                                                type="email"
                                                                                name="email_id"
                                                                                placeholder='Email Address'
                                                                                value={editFrontDeskState.email_id || ""}
                                                                                onChange={(oEvent) => fnOnChange(oEvent, editFrontDeskState, setEditFrontDeskState, editFrontDeskErrors, setEditFrontDeskErrors)}
                                                                                isInvalid={editFrontDeskErrors.email_id}
                                                                            />
                                                                            <Form.Control.Feedback type="invalid">{editFrontDeskErrors.email_id}</Form.Control.Feedback>
                                                                        </Form.Group>

                                                                        <Form.Group className="mb-3" controlId="formFrontDeskStatus">
                                                                            <Form.Label>Front Desk Status</Form.Label>
                                                                            <Form.Control
                                                                                as={FormSelect}
                                                                                name="status"
                                                                                value={editFrontDeskState.status || ""}
                                                                                onChange={(oEvent) => fnOnChange(oEvent, editFrontDeskState, setEditFrontDeskState, editFrontDeskErrors, setEditFrontDeskErrors)}
                                                                                isInvalid={editFrontDeskErrors.status}>
                                                                                <option value="">Select Status</option>
                                                                                <option value="A">Active</option>
                                                                                <option value="I">Inactive</option>
                                                                            </Form.Control>
                                                                            <Form.Control.Feedback type="invalid">{editFrontDeskErrors.status}</Form.Control.Feedback>
                                                                        </Form.Group>

                                                                        <Form.Group className="mb-3" controlId="formBranch">
                                                                            <Button type="submit" variant="primary" className="form-control" onClick={onPressEditFrontDeskSubmit}>
                                                                                {isEditFronDeskSubmitting ? 'Submitting...' : 'Submit Front Desk'}
                                                                            </Button>
                                                                        </Form.Group>
                                                                    </Form>
                                                                </Modal.Body>
                                                            </Modal>
                                                        </td>
                                                    </tr>
                                                ]
                                            })}
                                        </tbody>
                                    </Table>
                                    : <> </>}
                            </Tab>
                        </Tabs>
                    </div>
                    <ToastContainer />
                    <BusyLoaderOverlay show={loading} />
                </Row>
            </Container>
        </>
    )
}

export default ClinicDetails